<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <example-title src="example-1.html" title="Material Icons" url="http://icons.wemakesites.net/#/material.io" />
    <vc-layout>
      <vc-col :class="['align-center']" :span="4" md8 v-for="(size, index) in sizes.length" :key="index">
        <h4 :class="sizeHeading" v-html="sizes[index]" />
        <vc-icon :size="sizes[index]">home</vc-icon>
      </vc-col>
    </vc-layout>
    <example-title src="example-1.html" title="Font Awesome" url="http://icons.wemakesites.net/#/fontawesome.com" />
    <vc-layout>
      <vc-col :class="['align-center']" :span="4" md8 v-for="(size, index) in sizes.length" :key="index">
        <h4 :class="sizeHeading" v-html="sizes[index]" />
        <vc-icon color="primary" :size="sizes[index]">fa-align-justify</vc-icon>
      </vc-col>
    </vc-layout>
    <example-title src="example-1.html" title="Material Design Icons" url="http://icons.wemakesites.net/#/materialdesignicons.com" />
    <vc-layout>
      <vc-col :class="['align-center']" :span="4" md8 v-for="(size, index) in sizes.length" :key="index">
        <h4 :class="sizeHeading" v-html="sizes[index]" />
        <vc-icon color="orange" :size="sizes[index]">mdi-airplane</vc-icon>
      </vc-col>
    </vc-layout>
    <example-title src="example-1.html" title="Weather Icons" url="http://icons.wemakesites.net/#/weathericons.io" />
    <vc-layout>
      <vc-col :class="['align-center']" :span="4" md8 v-for="(size, index) in sizes.length" :key="index">
        <h4 :class="sizeHeading" v-html="sizes[index]" />
        <vc-icon color="deep-purple" :size="sizes[index]">wi-day-sunny</vc-icon>
      </vc-col>
    </vc-layout>
    <example-title src="example-1.html" title="Ionic Icons" url="http://icons.wemakesites.net/#/ionicons.com" />
    <vc-layout>
      <vc-col :class="['align-center']" :span="4" md8 v-for="(size, index) in sizes.length" :key="index">
        <h4 :class="sizeHeading" v-html="sizes[index]" />
        <vc-icon color="red l-800" :size="sizes[index]">ion-ionic</vc-icon>
      </vc-col>
    </vc-layout>
    <example-title src="example-1.html" title="Emoji CSS" url="http://icons.wemakesites.net/#/emoji-css" />
    <vc-layout>
      <vc-col :class="['align-center']" :span="4" md8 v-for="(size, index) in sizes.length" :key="index">
        <h4 :class="sizeHeading" v-html="sizes[index]" />
        <vc-icon :size="sizes[index]">em-avocado</vc-icon>
      </vc-col>
    </vc-layout>
    <example-title src="example-1.html" title="Government Icons" url="http://icons.wemakesites.net/#/govicons.io" />
    <vc-layout>
      <vc-col :class="['align-center']" :span="4" md8 v-for="(size, index) in sizes.length" :key="index">
        <h4 :class="sizeHeading" v-html="sizes[index]" />
        <vc-icon color="green" :size="sizes[index]">gi-radioactive</vc-icon>
      </vc-col>
    </vc-layout>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'IconPage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null,
      sizeHeading: ['body-2', 'font-grey', 'font-l-600'],
      sizes: [
        'x-small',
        'small',
        'normal',
        'medium',
        'large',
        'x-large'
      ]
    }
  },
  mounted () {
    this.getPage()
  },
  created () {
    this.sizes = this.sizes.reverse()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/icon.vue